<template>
    <div class="appdetail">
            <!-- 标题、按钮 -->
            <div class="appdetail-title">
                <div class="appdetail-title-top clearfix">
                    <div class="app-buttons">
                        <el-button icon="icon-save" class="btn-" type="primary" size="mini" @click="saveBtn('Update')">
                            <font>保存</font>
                        </el-button>
                        <el-button type="success" class="btn-" size="mini" @click="saveBtn('Submit')" v-show="addtitle">保存并继续</el-button>
                    </div>
                </div>
            </div>
            <el-tabs class="appdetail-content" type="border-card" v-model="currentDetailTabsModel" @tab-click="tabClick">
              <el-tab-pane label="列表" name="列表">
              </el-tab-pane>
              <el-tab-pane label="详情" name="详情">
                  <div class="appdetail-content" :style="{height: 'calc(100vh - 205px)'}">
                <el-form :show-message="false" inline-message :model="dataInfo" :rules="rules" ref="dataInfo" label-width="110px" class="demo-adduserForm">
                    <div class="content-accordion" id="information">
                      <el-collapse v-model="activeNames">
                          <el-collapse-item title="应用管理" name="1">
                          <el-row>
                              <el-col :span="8">
                              <el-form-item label="应用英文名称" prop="code">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.code"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="应用名称" prop="name">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.name"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="处理类" prop="handleclass">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.handleclass"></el-input>
                              </el-form-item>
                              </el-col>
                          </el-row>
                          <el-row>
                              <el-col :span="8">
                              <el-form-item label="类型" prop="type">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.type"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="应用描述" prop="description">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.description"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="数据库表" prop="objectdesc">
                                  <el-input placeholder="请选择" v-model="dataInfo.objectdesc" :disabled="true">
                                  <el-button slot="append" icon="el-icon-search" @click="getdatabase"></el-button>
                                  </el-input>
                              </el-form-item>
                              </el-col>
                          </el-row>
                          <el-row>
                              <el-col :span="8">
                              <el-form-item label="模块" prop="module">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.module"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="排序" prop="sort">
                                  <el-input :placeholder="noedit?'':'请输入'" v-model="dataInfo.sort"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="流程" prop="flowname">
                                  <el-input placeholder="请选择" v-model="dataInfo.flowname" :disabled="true">
                                  <el-button slot="append" icon="el-icon-search" @click="getFlow"></el-button>
                                  </el-input>
                              </el-form-item>
                              </el-col>
                          </el-row>
                          <el-row>
                              <el-col :span="8">
                              <el-form-item label="流程待办单据号" prop="flow_todo_num">
                                  <el-input placeholder="请选择" v-model="dataInfo.flow_todo_num" :disabled="true">
                                  <el-button slot="append" icon="el-icon-search" @click="getFlowlist(1)"></el-button>
                                  </el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="流程待办描述" prop="flow_todo_desc">
                                  <el-input placeholder="请选择" v-model="dataInfo.flow_todo_desc" :disabled="true">
                                  <el-button slot="append" icon="el-icon-search" @click="getFlowlist(2)"></el-button>
                                  </el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <!--<el-form-item label="报表类型" prop="reportId" label-width="100px">
                                                          <el-select v-model="dataInfo.reportId" multiple  default-first-option  >
                                                              <el-option v-for="item in selectData" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                                          </el-select>
                              </el-form-item>-->

                              <!--<el-form-item label="报表类型" prop="reportId" label-width="100px">
                                                          <el-select v-model="dataInfo.reportId" multiple  default-first-option  >
                                                              <el-option v-for="item in selectData" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                                          </el-select>
                              </el-form-item>-->
                              </el-col>

                              <!-- <el-col :span="8">
                              <el-form-item label="报表类型" prop="reportId">
                                  <el-select v-model="dataInfo.reportId" multiple>
                                  <el-option
                                      v-for="item in selectData"
                                      :key="item.id"
                                      :value="item.id"
                                      :label="item.name"
                                  ></el-option>
                                  </el-select>
                              </el-form-item>
                              </el-col>-->
                          </el-row>
                          </el-collapse-item>
                          <el-collapse-item title="报表类型" name="2">
                          <!-- 字段列表 Begin-->
                          <div class="table-func pull-right">
                              <el-button type="success" size="mini" @click="addfield">
                              <i class="icon-add"></i>
                              <font>新建</font>
                              </el-button>
                          </div>
                          <el-table :data="dataInfo.reports" row-key="ID" border stripe height="260" highlight-current-row="highlight-current-row" style="width: 100%;" :default-sort="{prop:'dataInfo.reports', order: 'descending'}">
                              <el-table-column label="序号" prop="iconOperation" fixed width="50px">
                              <template slot-scope="scope">
                                  <span v-show="!scope.row.isEditing">{{scope.$index+1}}</span>
                              </template>
                              </el-table-column>
                              <el-table-column label="报表编号" sortable width="280px" prop="code">
                              <template slot-scope="scope">
                                  <span>{{scope.row.code}}</span>
                              </template>
                              </el-table-column>
                              <el-table-column label="报表名称" sortable width="280px" prop="name">
                              <template slot-scope="scope">
                                  <span>{{scope.row.name}}</span>
                              </template>
                              </el-table-column>
                              <el-table-column label="报表类型" sortable prop="typeDesc">
                              <template slot-scope="scope">
                                  <span>{{scope.row.typeDesc}}</span>
                              </template>
                              </el-table-column>
                              <el-table-column fixed="right" label="操作" width="60">
                              <template slot-scope="scope">
                                  <el-button @click="deleteRow(scope.$index,scope.row)" type="text" size="small">
                                  <i class="icon-trash red"></i>
                                  </el-button>
                              </template>
                              </el-table-column>
                          </el-table>
                          <!-- 字段列表 End -->
                          </el-collapse-item>
                          <el-collapse-item title="其他" name="3" v-show="views">
                          <el-row>
                              <el-col :span="8">
                              <el-form-item label="录入人" prop="createuserdesc">
                                  <el-input v-model="dataInfo.createuserdesc" :disabled="edit"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="录入时间" prop="createtime">
                                  <el-input v-model="dataInfo.createtime" :disabled="edit"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="机构" prop="deptiddesc" label-width="100px">
                                  <el-input v-model="dataInfo.deptiddesc" placeholder="当前录入人机构" :disabled="edit"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="修改人" prop="updateuserdesc">
                                  <el-input v-model="dataInfo.updateuserdesc" placeholder="当前修改人" :disabled="edit"></el-input>
                              </el-form-item>
                              </el-col>
                              <el-col :span="8">
                              <el-form-item label="变更时间" prop="updatetime">
                                  <el-input v-model="dataInfo.updatetime" placeholder="当前修改时间" :disabled="edit"></el-input>
                              </el-form-item>
                              </el-col>
                          </el-row>
                          </el-collapse-item>
                      </el-collapse>
                      </div>
                  </el-form>
              </div>
              </el-tab-pane>
            </el-tabs>
      <reportmask ref="reportmask" @reportid="reportid" @reports="reports"></reportmask>
      <vchoose ref="choose" :chooseParam="chooseParam" @tranFormData="updateChoose"></vchoose>
  </div>
</template>

<script>

import reportmask from "./reportmask.vue";
import vchoose from "@/components/commonComponents/dataselect.vue";
export default {
  name: "masks",
  components: {
    reportmask,
    vchoose
  },
  data() {
    return {
      currentDetailTabsModel:"详情",
      drawer:false,
      basic_url: Config.dev_url,
      file_url: Config.dev_url,
      selUser: [],
      edit: true, //禁填
      show: false,
      isok1: true,
      isok2: false,
      activeNames: ["1", "2", "3"], //手风琴数量
      dialogVisible: false, //对话框
      selectData: [],
      //tree
      addtitle: true,
      noedit: false, //可编辑
      views: false, //录入修改人信息
      modify: false, //修订
      hintshow: false,
      loading: false, //默认加载数据时显示loading动画
      rules: {
        //应用英文名称
        code: [
          {
            required: true,
            message: "请填写",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: this.Validators.isEnglish
          }
        ],
        //数据库表
        object_id: [
          {
            required: true,
            message: "请填写",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: this.Validators.isEnglish
          }
        ],
        //应用名称
        name: [
          {
            required: true,
            message: "请填写",
            trigger: "blur"
          },
          {
            trigger: "blur",
            validator: this.Validators.isSpecificKey
          }
        ],
        //处理类
        // handleclass: [{
        //     required: true,
        //     message: '请填写',
        //     trigger: 'blur'
        // }],
        //排序
        sort: [
          {
            required: false,
            trigger: "blur",
            validator: this.Validators.isInteger
          }
        ],
        //应用描述
        description: [
          {
            required: true,
            message: "请填写",
            trigger: "blur"
          }
        ]
      },
      dataInfo: {
        reports: []
      },
      chooseParam: {}
    };
  },
  methods: {
    //人员
    addfield() {
      var chooseParam = {
        title: "报表类型",
        isMulti: false,
        searchBtn: true,
        tableHeader: [
          {
            propName: "code",
            labelName: "报表编号",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "name",
            labelName: "报表名称",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "typeDesc",
            labelName: "报表类型",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "file",
            labelName: "文件",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "createtime",
            labelName: "录入时间",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "updatetime",
            labelName: "修改时间",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          }
        ],
        search: [],
        url: "/api-report/report",
        method: "get"
      };
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    //删除行
    deleteRow(index, row) {
      console.log(row);
      if (row.id) {
        var url = this.file_url + "/api-report/report/deleteappreport/" + row.id;
        this.$axios
          .delete(url, {})
          .then(res => {
            if (res.data.resp_code == 0) {
              this.dataInfo.reports.splice(index, 1);
              this.$message({
                message: "删除成功",
                type: "success"
              });
            } else {
              this.$message({
                message: res.data.resp_msg,
                type: "error"
              });
            }
          })
          .catch(err => { });
      } else {
        this.dataInfo.reports.splice(index, 1);
      }
    },
    reportid(value) {
      this.dataInfo.reportId = value;
    },
    reports(value) {
      this.dataInfo.report = value.toString();
    },
    //获取导入表格勾选信息
    SelChange(val) {
      this.selUser = val;
    },
    //添加显示弹窗
    addBtn() {
        this.dataInfo = {
            id: "",
            name: "",
            num: "",
            deptcode: "",
            deptiddesc: "",
            createuserdesc: "",
            createtime: "",
            updateuserdesc: "",
            updatetime: "",
            del_flag: ""
        };
        this.currentDetailTabsModel = "详情"
        this.addtitle = true;

      this.isok2 = false;
      this.isok1 = true;
    },
    //这是查看
    view(val) {
      this.currentDetailTabsModel = "详情"
      this.detailData = val;
      var id = this.detailData.id;
      this.getData(id);
      this.getupdateuserdesc()
      this.getcreateuserdesc()
      this.addtitle = false;

      this.isok2 = false;
      this.isok1 = true;
    },
    // //获取当前用户信息
    // getUser(opt) {
    //   var url = Config.dev_url + "/api-user/users/currentMap";
    //   this.$axios
    //     .get(url, {})
    //     .then(res => {
    //       if (opt == "new") {
    //         this.dataInfo.createuser = res.data.id;
    //         this.dataInfo.createuserdesc = res.data.nickname;
    //         this.dataInfo.createtime = this.getToday();
    //       } else {
    //         this.dataInfo.updateuser = res.data.id;
    //         this.dataInfo.updateuserdesc = res.data.nickname;
    //         this.dataInfo.updatetime = this.getToday();
    //       }
    //     })
    //     .catch(err => { });
    // },
    //获取当前时间
    getToday() {
      var date = new Date();
      var month = date.getMonth();
      month++;
      var str =
        date.getFullYear() +
        "-" +
        month +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      var rate = this.$moment(str).format("YYYY-MM-DD HH:mm:ss");
      return rate;
    },
    //获取当前组信息
    getData(id) {
      var url = Config.dev_url + "/api-apps/appcfg/" + id;
      this.$axios
        .get(url, {})
        .then(res => {
          this.dataInfo = res.data;
          this.show = true;
        })
        .catch(err => { });
    },
    //点击关闭按钮
    close() {
      this.resetForm();
      this.show = false;
      this.$emit("request"); //关闭弹框去掉勾选
    },
    //tab选项卡点击
    tabClick(tab){
        if(tab.label == "列表"){
            this.$store.commit('setcurrentShowPage',1)
            this.resetForm();
            this.show = false;
            this.$emit("request"); //关闭弹框去掉勾选
        }else{
            this.$store.commit('setcurrentShowPage',2)
        }
    },
    resetForm() {
      this.dataInfo = {
        id: "",
        name: "",
        num: "",
        deptcode: "",
        deptiddesc: "",
        createuserdesc: "",
        createtime: "",
        updateuserdesc: "",
        updatetime: "",
        del_flag: ""
      };
      this.show = false;
    },
    // 保存users/saveOrUpdate
    saveBtn(parameter) {
      this.loading = true;
      var _this = this;
      this.$refs.dataInfo.validate(valid => {
        if (valid) {
          var dataInfo = _this.dataInfo;
          console.log(this.dataInfo);
          var url = Config.dev_url + "/api-apps/appcfg/saveOrUpdate";
          this.$axios
            .post(url, this.dataInfo)
            .then(res => {
              //resp_code == 0是后台返回的请求成功的信息
              if (res.data.code == 0) {
                this.loading = false;
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                if(parameter == 'Submit'){
                    this.dataInfo = {
                        id: "",
                        name: "",
                        num: "",
                        deptcode: "",
                        deptiddesc: "",
                        createuserdesc: "",
                        createtime: "",
                        updateuserdesc: "",
                        updatetime: "",
                        del_flag: ""
                    };
                }
              } else {
                if (res.data.code == 1) {
                  this.loading = false;
                  //res.data.resp_msg!=''后台返回提示信息
                  if (res.data.msg != "") {
                    this.$message({
                      message: res.data.msg,
                      type: "error"
                    });
                  } else {
                    this.$message({
                      message: "相同数据不可重复添加！",
                      type: "warning"
                    });
                  }
                }
              }
            })
            .catch(err => { });
        } else {
          this.$message({
            message: "未填写完整，请填写",
            type: "warning"
          });
        }
      });
    },
    getdatabase() {
      var chooseParam = {
        title: "数据库表",
        searchBtn: true,
        tableHeader: [
          {
            propName: "id",
            labelName: "编号",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "name",
            labelName: "名称",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "description",
            labelName: "描述",
            isShow: "yes",
            isSearch: "no",
            width: "35%"
          }
        ],
        search: [],
        url: "/api-apps/appcfg/object",
        method: "get"
      };
      var target = this.dataInfo;
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        chooseParam.tableHeader[i].targetObject = target;
      }
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    //流程
    getFlow() {
      var chooseParam = {
        title: "流程",
        searchBtn: true,
        tableHeader: [
          {
            propName: "id",
            labelName: "编号",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "name",
            labelName: "描述",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          }
        ],
        search: [],
        url: "/api-flow/flow/model",
        method: "get"
      };
      var target = this.dataInfo;
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        chooseParam.tableHeader[i].targetObject = target;
      }
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    //流程代办单据号
    getFlowlist(flow) {
      if (!this.dataInfo.objectdesc || !this.dataInfo.objectId) {
        this.$message({
          message: "请先选取数据库表",
          type: "warning"
        });
        return;
      }
      this.getFlownum = flow;
      var chooseParam = {
        title: "流程代办单据",
        searchBtn: true,
        tableHeader: [
          {
            propName: "columnname",
            labelName: "字段",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          },
          {
            propName: "description",
            labelName: "描述",
            isShow: "yes",
            isSearch: "yes",
            width: "35%"
          }
        ],
        search: [],
        url:
          "/api-apps/appcfg/findAttrsByObjId?ObjId=" + this.dataInfo.objectId,
        method: "get"
      };
      var target = this.dataInfo;
      for (var i = 0; i < chooseParam.tableHeader.length; i++) {
        chooseParam.tableHeader[i].targetObject = target;
      }
      this.chooseParam = chooseParam;
      this.$refs.choose.getListData("new", this.chooseParam);
    },
    updateChoose(data) {
      if (!!data[0].key) {
        this.dataInfo.flowkey = data[0].key;
        this.dataInfo.flowname = data[0].name;
      } else if (data[0].hasOwnProperty("attributes")) {
        this.dataInfo.objectId = data[0].id;
        this.dataInfo.objectdesc = data[0].description;
      } else if (data[0].hasOwnProperty("typeDesc")) {
        setTimeout(() => {
          this.dataInfo.reports.push(data[0]);
        })
      } else if (data[0].hasOwnProperty("columnname") && this.getFlownum == 1) {
        this.dataInfo.flow_todo_num = data[0].columnname;
      } else if (data[0].hasOwnProperty("columnname") && this.getFlownum == 2) {
        this.dataInfo.flow_todo_desc = data[0].columnname;
      }
      this.$forceUpdate();
    },
    //报表参数类
    getreport() {
      var url = Config.dev_url + "/api-report/report";
      this.$axios
        .get(url, {})
        .then(res => {
          this.selectData = res.data.data;
        })
        .catch(wrong => { });
    },
    //关闭抽屉按钮点击
    closeBtn(){
        this.drawer = false
        this.$emit("requestData")
    },
    //获取创建人描述
    getcreateuserdesc() {
        if (!!this.dataInfo.createuser) {
            var url = Config.dev_url + '/api-user/users/' + this.dataInfo.createuser
            this.$axios.get(url).then((res) => {
                this.$set(this.dataInfo, 'createuserdesc', res.data.nickname)
            })
        }
    },
    //获取修改人描述
    getupdateuserdesc() {
        if (!!this.dataInfo.updateuser) {
            var url = Config.dev_url + '/api-user/users/' + this.dataInfo.updateuser
            this.$axios.get(url).then((res) => {
                this.$set(this.dataInfo, 'updateuserdesc', res.data.nickname)
            })
        }
    },
  },
  mounted() {
  },
  computed:{
        //当前左侧菜单选中的信息
        currentSelectMenuData(){
            return this.$store.state.currentSelectMenuData
        },
        //当前登录人信息
        currentuser() {
            return this.$store.state.currentuser
        },
    }
};
</script>

<style scoped>
</style>
